<template>
  <div class="text-start mx-1">
    <v-dialog v-model="isOpen" width="500">
      <template v-slot:activator="{ on, attrs }">
        <v-icon small color="blue darken-2" class="mx-2" v-bind="attrs" v-on="on">mdi-comment-edit</v-icon>
      </template>
      <v-card>
        <v-card-title class="text-h5 lighten-2">
          <v-icon color="primary" class="mr-2" v-bind="attrs" v-on="on">mdi-comment-edit</v-icon>
          Comment
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-textarea auto-grow clearable label="Enter comment" type="text" v-model="comment" required></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="handleClose"> Close </v-btn>
          <v-btn color="primary" text @click="handleSubmit"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PrescriptionService from '../../../services/prescription';

export default {
  name: 'AddCommentDialog',
  props: ['epresOrder'],
  data() {
    return {
      isOpen: false,
      comment: '',
    };
  },
  methods: {
    handleClose() {
      this.isOpen = false;
      this.comment = this.epresOrder.comment;
    },
    handleSubmit() {
      const prescriptionId = this.epresOrder.value._id;
      const param = {
        comment: this.comment,
      };

      PrescriptionService.updateComment(prescriptionId, param)
        .then(() => (this.isOpen = false))
        .catch((err) => console.log(err));
    },
  },
  mounted() {
    this.comment = this.epresOrder.comment;
  },
};
</script>
